var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 164.273,
    height: 44.01,
    viewBox: "0 0 164.273 44.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 164.273,
    height: 44.01,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2626",
    "data-name": "Groupe 2626",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5992",
    "data-name": "Trac\\xE9 5992",
    d: "M220.493,66.4l7.2,7.207L234.9,66.4,227.7,59.2Z",
    transform: "translate(-110.246 -29.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 10.192,
    height: 10.192,
    transform: "translate(120.189 7.207) rotate(-45.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5993",
    "data-name": "Trac\\xE9 5993",
    d: "M220.6,26.988l7.2,7.208,7.206-7.208-7.206-7.2Z",
    transform: "translate(-110.301 -9.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 10.191,
    height: 10.191,
    transform: "translate(100.41 26.989) rotate(-45.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5994",
    "data-name": "Trac\\xE9 5994",
    d: "M181.042,65.747h14.409l-7.2-7.206Z",
    transform: "translate(-90.52 -29.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5995",
    "data-name": "Trac\\xE9 5995",
    d: "M260.159,26.988l7.206,7.208,7.2-7.208-7.2-7.2Z",
    transform: "translate(-130.079 -9.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5996",
    "data-name": "Trac\\xE9 5996",
    d: "M279.941,46.771l7.2,7.2,7.207-7.2-7.207-7.209Z",
    transform: "translate(-139.97 -19.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5997",
    "data-name": "Trac\\xE9 5997",
    d: "M260.159,65.747H274.57l-7.2-7.206Z",
    transform: "translate(-130.079 -29.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5998",
    "data-name": "Trac\\xE9 5998",
    d: "M299.719,65.747h14.413l-7.206-7.206Z",
    transform: "translate(-149.859 -29.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5999",
    "data-name": "Trac\\xE9 5999",
    d: "M239.518,46.789l7.2,7.207,7.206-7.207-7.206-7.2Z",
    transform: "translate(-119.759 -19.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2625",
    "data-name": "Groupe 2625",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2624",
    "data-name": "Groupe 2624",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6000",
    "data-name": "Trac\\xE9 6000",
    d: "M0,20.989c0-3.916,2.452-6.667,6.191-6.667a5.384,5.384,0,0,1,5.538,3.986L8.89,18.8a2.665,2.665,0,0,0-2.7-2.1c-2.011,0-3.246,1.64-3.246,4.3,0,2.646,1.235,4.287,3.246,4.287a2.764,2.764,0,0,0,2.787-2.276l2.84.494a5.507,5.507,0,0,1-5.644,4.163C2.5,27.674,0,24.957,0,20.989",
    transform: "translate(0 -7.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6001",
    "data-name": "Trac\\xE9 6001",
    d: "M34.945,25.381H29.83l-.776,2.293H26.108L30.87,14.886h3.263l4.745,12.788H35.721Zm-.847-2.54-1.693-5.08-1.711,5.08Z",
    transform: "translate(-13.054 -7.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6002",
    "data-name": "Trac\\xE9 6002",
    d: "M69.995,14.886V27.673H67.278v-9.9l-2.893,9.9H61.758l-2.857-9.9v9.9H56.237V14.886h4.339l2.54,8.872,2.54-8.872Z",
    transform: "translate(-28.118 -7.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6003",
    "data-name": "Trac\\xE9 6003",
    d: "M101.537,19.155c0,2.558-1.852,4.251-4.639,4.251h-2.84v4.269H91.166V14.886H96.9c2.787,0,4.639,1.694,4.639,4.269m-4.956,1.782c1.27,0,2.011-.653,2.011-1.782,0-1.147-.741-1.8-2.011-1.8H94.059v3.581Z",
    transform: "translate(-45.583 -7.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6004",
    "data-name": "Trac\\xE9 6004",
    d: "M116.78,21.994V14.885h2.893v7.144c0,2.417.775,3.546,2.5,3.546,1.693,0,2.469-1.094,2.469-3.546V14.885h2.875v7.109c0,3.934-1.782,5.962-5.362,5.962-3.545,0-5.38-1.993-5.38-5.962",
    transform: "translate(-58.39 -7.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6005",
    "data-name": "Trac\\xE9 6005",
    d: "M143.417,24.129l2.752-.811a2.951,2.951,0,0,0,3.016,2.046c1.411,0,2.311-.635,2.311-1.552,0-1.041-1.111-1.288-2.893-1.729-2.575-.653-4.727-1.305-4.727-3.845,0-2.452,1.975-3.916,5.01-3.916,2.575,0,4.48,1.094,5.1,2.981l-2.752.812a2.548,2.548,0,0,0-2.487-1.482c-1.147,0-2.028.512-2.028,1.323,0,.988,1.147,1.235,2.91,1.676,2.734.688,4.692,1.393,4.692,3.845,0,2.557-2.1,4.2-5.257,4.2-2.91,0-5.186-1.393-5.644-3.545",
    transform: "translate(-71.708 -7.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6006",
    "data-name": "Trac\\xE9 6006",
    d: "M1.411,47.062h8.872v2.469H4.3v3.175H9.63v2.469H4.3v4.674H1.411Z",
    transform: "translate(-0.705 -23.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6007",
    "data-name": "Trac\\xE9 6007",
    d: "M34.4,59.849l-2.8-4.445H29.847v4.445H26.954V47.062h5.662c2.822,0,4.71,1.676,4.71,4.18a3.883,3.883,0,0,1-2.752,3.845l3.158,4.762Zm-4.551-6.879h2.17c1.588,0,2.364-.565,2.364-1.729,0-1.076-.706-1.711-1.905-1.711H29.847Z",
    transform: "translate(-13.477 -23.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6008",
    "data-name": "Trac\\xE9 6008",
    d: "M62,57.556H56.89l-.776,2.293H53.168L57.93,47.062h3.263l4.745,12.787H62.781Zm-.847-2.54-1.693-5.08-1.711,5.08Z",
    transform: "translate(-26.584 -23.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6009",
    "data-name": "Trac\\xE9 6009",
    d: "M85.661,47.062h2.946l4.921,8.325V47.062h2.84V59.849H93.422L88.5,51.524v8.325h-2.84Z",
    transform: "translate(-42.831 -23.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6010",
    "data-name": "Trac\\xE9 6010",
    d: "M115.439,53.165c0-3.916,2.452-6.667,6.191-6.667a5.385,5.385,0,0,1,5.538,3.986l-2.84.494a2.666,2.666,0,0,0-2.7-2.1c-2.011,0-3.246,1.64-3.246,4.3,0,2.646,1.235,4.287,3.246,4.287a2.764,2.764,0,0,0,2.787-2.276l2.84.494a5.507,5.507,0,0,1-5.644,4.163c-3.669,0-6.174-2.717-6.174-6.685",
    transform: "translate(-57.719 -23.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6011",
    "data-name": "Trac\\xE9 6011",
    d: "M146.732,47.062h9.3v2.469h-6.4v2.593h5.662v2.434h-5.662V57.38h6.667v2.469h-9.56Z",
    transform: "translate(-73.366 -23.531)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aa7e2ac1a91e4b90f475d4a977bf3317.svg";
export { ForwardRef as ReactComponent };